import { toast, ToastOptions } from "react-toastify";

const defaultOptions: ToastOptions = {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
};

export function showToastSuccess(message: string, options?: ToastOptions) {
    toast.success(message, { ...defaultOptions, ...options });
}


export function showToastError(message: string, options?: ToastOptions) {
    toast.error(message, { ...defaultOptions, ...options });
}


export function showToastInfo(message: string, options?: ToastOptions) {
    toast.info(message, { ...defaultOptions, ...options });
}


export function showToastWarning(message: string, options?: ToastOptions) {
    toast.warn(message, { ...defaultOptions, ...options });
}

export function showToastUnchanged(message: string, options?: ToastOptions) {
    toast.info(message, { ...defaultOptions, ...options, className: "toast-unchanged" });
}
